module.exports = {
  'environment': "production",
  'publicPath': o => `${o.repository}/assets/${o.name}/${o.version}/`,
  'rbac': {
  'role': () => '',
  'permission': {
},
  'grants': {
},
},
  'name': "accounts-frontend-login",
  'version': "1.1.112",
  'events': {
  'listeners': [],
  'emitters': [],
},
  'mfeDependencies': [],
  'intl': {
  'language': "pt-BR",
  'fallbackLng': "pt-BR",
  'debug': false,
  'locales': "{,!(node_modules)/**/}locales/*.json",
},
}